export default "__VITE_ASSET__BYyGkEtz__"